module.exports = __webpack_public_path__ + "static/media/expand-circle-white.8543405d.svg";